import 'javascripts/all_pages.js'
import 'javascripts/all_theme_styles.js'
import 'javascripts/nav_auto_scroll.js'
import {videoModal} from "../../javascripts/general_scripts"

videoModal();

$('#filter-category').change( function() {
    let categoryId = $(this).val();
    let maxShownProducts = 10;
    let matchingProducts = $('.product-card').filter((i, prod) => $(prod).data('categories').includes(parseInt(categoryId)));
    let nonMatchingProducts = $('.product-card').not(matchingProducts);

    $('.product-card').parents('.row').removeClass('d-none filter-none'); // reset all products
    nonMatchingProducts.parents('.row').addClass('filter-none'); // hide all products not in this category
    if(matchingProducts.length > maxShownProducts) {
        // show the first 10 products only with a more link
        matchingProducts.slice(maxShownProducts).parents('.row').addClass('d-none');
        $('.more-products-cnt').html(matchingProducts.length - maxShownProducts);
        $('#more-products').parent().show();
    }
});

$('#more-products').click(function(e) {
    e.preventDefault();
    $('.product-card').parents('.row').removeClass('d-none');
    $(this).parent().hide();
});
